module.exports = __webpack_public_path__ + "img/formImg.f69420d4.jpg";